import { render, staticRenderFns } from "./ModalAddOrUpdateHoliday.vue?vue&type=template&id=f2a88a0a"
import script from "./ModalAddOrUpdateHoliday.vue?vue&type=script&lang=js"
export * from "./ModalAddOrUpdateHoliday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports